import AnalysingScreen from "@components/Onboarding/Intro/AnalysingScreen";
import { router } from "expo-router";
import { useCallback } from "react";

export default function AnalysingRoute() {
  const handleComplete = useCallback(() => {
    router.navigate("/onboarding/aha-1");
  }, []);

  return <AnalysingScreen onComplete={handleComplete} />;
}
